import { gridSize } from '@/shared/constants/ui.constants';
import { colorSistema } from '@/shared/utils/appColor';
import { useUiStore } from '@/store/ui/ui.store';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material';

export type CustomConfirmDialogProps = {};

const CustomConfirmDialog: React.FC<CustomConfirmDialogProps> = () => {
  const open = useUiStore(s => s.confirmDialog.isOpen);
  const title = useUiStore(s => s.confirmDialog.title);
  const subtitle = useUiStore(s => s.confirmDialog.subtitle);
  const onClose = useUiStore(s => s.confirmDialog.onClose);
  const onReject = useUiStore(s => s.confirmDialog.onReject);
  const onConfirm = useUiStore(s => s.confirmDialog.onConfirm);
  //const btnTitle = useUiStore(s => s.confirmDialog.btnTitle);
  const cancelTextBtn = useUiStore(s => s.confirmDialog.cancelTextBtn);
  const confirmTextBtn = useUiStore(s => s.confirmDialog.confirmTextBtn);

  const shwoCustomInputsForm = useUiStore(
    s => s.confirmDialog.shwoCustomInputsForm
  );
  const inputsForm = useUiStore(s => s.confirmDialog.inputsForm);

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>

      <DialogContent>
        <Typography
          variant="subtitle1"
          sx={{ color: colorSistema.default[600] }}
        >
          {subtitle}
        </Typography>

        {/* ------ Modal FORM ------ */}
        {shwoCustomInputsForm && (
          <Grid container justifyContent="center" alignItems="center" pt={4} pb={1}>
            <Grid item {...gridSize}>
              {inputsForm}
            </Grid>
          </Grid>
        )}
      </DialogContent>

      <DialogActions>
        <Grid container justifyContent={'space-between'}>
          <Grid item >
            {
              onClose && (
                <Button onClick={onClose} sx={{ color: colorSistema.default[600] }}>
                  {cancelTextBtn ?? 'Cancelar'}
                </Button>
                
              )
            }

          </Grid>

          <Grid item >

            {onReject && <Button
              onClick={onReject}
              variant='text'
              style={{
                color: colorSistema.default[600]
              }}
            >
              {'Rechazar'}
            </Button>}


            {
              onConfirm && (<Button
                onClick={onConfirm}
                style={{
                  color: colorSistema.default[100],
                  background: colorSistema.default[900],
                }}
              >
                {confirmTextBtn ?? 'Confirmar'}
              </Button>)
            }

          </Grid>

        </Grid>




      </DialogActions>
    </Dialog>
  );
};

export default CustomConfirmDialog;
